import React from 'react';

import messages from '../messages';
import { PlusIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import {
  Button,
  Stack,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { TableHeader } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import useIntl from '../../../hooks/useIntl';
import customize356010Messages from '../Customize356010Modal/messages';

const RentForecastHeader = (props) => {
  const {
    count,
    openRentForecastModal,
    totalCount,
    disableButtonModal,
    showCustomize356010,
    openCustomize356010Modal,
  } = props;
  const intl = useIntl();

  return (
    <TableHeader
      title={intl.formatMessage(messages.title)}
      actions={[
        <Stack key={2} direction="column" spacing={1}>
          <Button
            onClick={openRentForecastModal}
            variant="shout"
            disabled={disableButtonModal}
            startIcon={<PlusIcon />}
          >
            {intl.formatMessage(messages.createRentForecast)}
          </Button>
          {showCustomize356010 && (
            <Button onClick={openCustomize356010Modal} variant="shout">
              {intl.formatMessage(customize356010Messages.customizeButton)}
            </Button>
          )}
        </Stack>,
      ]}
      count={count}
      totalCount={totalCount}
    />
  );
};

export default RentForecastHeader;
